
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities",
      function () {
        return require("private-next-pages/activities/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities"])
      });
    }
  